import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Flame, Check, Euro, Snowflake, Zap } from 'lucide-react';

const SolutionChauffage = () => {
  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Hero */}
      <section style={{ paddingTop: '140px', paddingBottom: '64px', background: 'var(--bg-card)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center' }}>
            <div>
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Flame size={32} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h1 className="display-medium" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
                Installation Pompe à Chaleur
              </h1>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Chauffez et climatisez votre logement de manière économique et écologique. Jusqu'à 60% d'économies sur votre facture de chauffage.
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <Link to="/devis" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  Demander un devis gratuit
                  <ArrowRight size={20} />
                </Link>
                <a href="tel:0175438580" className="btn-secondary">
                  01 75 43 85 80
                </a>
              </div>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1509391366360-2e959784a276" alt="Pompe à chaleur" style={{ width: '100%', borderRadius: '32px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Pourquoi Choisir une Pompe à Chaleur ?
          </h2>
          <div className="network-grid">
            <div className="network-card">
              <Euro size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Jusqu'à 60% d'Économies</h3>
              <p className="network-card-content">
                Divisez votre facture de chauffage par 2 ou 3 grâce à un rendement exceptionnel.
              </p>
            </div>
            <div className="network-card">
              <Snowflake size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Chauffage + Climatisation</h3>
              <p className="network-card-content">
                Un seul équipement pour chauffer l'hiver et climatiser l'été (pompe réversible).
              </p>
            </div>
            <div className="network-card">
              <Zap size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Installation Rapide</h3>
              <p className="network-card-content">
                Installation en 1 à 2 jours par nos techniciens certifiés RGE QualiPAC.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Types de PAC */}
      <section className="pad-giant" style={{ background: 'var(--bg-card)' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Nos Solutions Pompe à Chaleur
          </h2>
          <div className="network-grid">
            <div className="network-card">
              <h3 className="network-card-title">PAC Air/Eau</h3>
              <p className="network-card-content">
                Idéale pour remplacer votre chaudière. Compatible avec radiateurs et plancher chauffant.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Système de chauffage central</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Production eau chaude sanitaire</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>COP jusqu'à 4 (1kW → 4kW)</span>
                </li>
              </ul>
            </div>
            <div className="network-card">
              <h3 className="network-card-title">PAC Air/Air</h3>
              <p className="network-card-content">
                Solution climatisation réversible. Chaud l'hiver, frais l'été. Installation murale ou gainable.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Climatisation réversible</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', marginBottom: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Installation rapide (1 jour)</span>
                </li>
                <li style={{ display: 'flex', gap: '8px', fontSize: '14px' }}>
                  <Check size={16} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
                  <span>Contrôle pièce par pièce</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Aides */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '24px', color: 'var(--text-primary)' }}>
            Aides Financières Disponibles
          </h2>
          <p className="body-large" style={{ textAlign: 'center', color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 48px' }}>
            Réduisez jusqu'à 90% le coût de votre installation
          </p>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'MaPrimeRénov\' jusqu\'à 10 000€',
                'Prime CEE (Certificats d\'Économie d\'Énergie)',
                'TVA réduite à 5.5%',
                'Éco-PTZ : prêt à taux zéro jusqu\'à 50 000€',
              ].map((item, index) => (
                <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', background: index % 2 === 0 ? 'var(--bg-card)' : 'transparent', borderRadius: '12px', marginBottom: '8px' }}>
                  <Check size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                  <span style={{ fontSize: '18px', color: 'var(--text-secondary)' }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pad-giant" style={{ background: 'var(--brand-dark)', textAlign: 'center' }}>
        <div className="container">
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '24px' }}>
            Intéressé par une Pompe à Chaleur ?
          </h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.9, maxWidth: '700px', margin: '0 auto 48px' }}>
            Faites des économies dès maintenant avec une installation clé en main
          </p>
          <Link to="/devis" className="btn-cta" style={{ background: 'var(--brand-primary)', color: 'var(--brand-dark)' }}>
            Demander mon devis gratuit
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SolutionChauffage;
